export enum Status {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
}

export interface Task {
  id: number
  name: string
  status: Status
}

export enum TaskType {
  LANDING_DIRECT_TOUR = 'Landing Direct Tour',
  LANDING_VERIFIED_WALKTHROUGH = 'Landing Verified Walkthrough',
  TURNOVER_HOME_INSPECTION = 'home inspection',
}
